import noop from '@lib/utils/noop';
import { ITask } from '@modules/TasksModule/types';
import {
  BodyText,
  Button,
  Card,
  Divider,
  Stack,
} from '@servicetitan/design-system';
import styles from './CustomTaskRow.module.css';
import classNames from 'classnames';
import EllipseAdornment from '@pages/agent/InboxPage/components/TaskRow/EllipseAdornment/EllipseAdornment';
import datetime from '@lib/utils/datetime';
import { SyntheticEvent } from 'react';
import useTaskActions from '@modules/TasksModule/hooks/useTaskActions';

type Props = {
  task: ITask;
  active: boolean;
  onClick?: () => void;
};

const CustomTaskRow = ({ task, active, onClick = noop }: Props) => {
  const { handleComplete } = useTaskActions(task.id);

  const handleClick = (event: SyntheticEvent) => {
    event.stopPropagation();
    onClick();
  };

  return (
    <div onClick={handleClick} data-testid={task.id}>
      <Card
        elevation='base'
        sharp
        onClick={handleClick}
        className={classNames(styles.CustomTaskRowCard, {
          [styles.CustomTaskRowCardActive]: active,
        })}
      >
        <Stack direction='column' spacing='1'>
          <Stack justifyContent='space-between' alignItems='center'>
            <BodyText size='small' bold={active}>
              {' ' + task.displayName}
            </BodyText>
            <EllipseAdornment>
              <BodyText size='xsmall' subdued>
                {datetime(task.startedAt).format('h:mma')}
              </BodyText>
            </EllipseAdornment>
          </Stack>
          <Stack
            className={styles.TaskTagRow}
            justifyContent='space-between'
            alignItems='center'
          >
            <div></div>
            <div>
              <Button onClick={handleComplete} outline size='xsmall'>
                Close
              </Button>
            </div>
          </Stack>
        </Stack>
      </Card>
      <Divider spacing='0' />
    </div>
  );
};

export default CustomTaskRow;
